module.exports = __webpack_public_path__ + "static/media/mobile-animation.b14790a1.gif";


//////////////////
// WEBPACK FOOTER
// ./src/img/mobile-animation.gif
// module id = 67
// module chunks = 0